import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LocationStrategy, HashLocationStrategy, PathLocationStrategy, DatePipe} from '@angular/common';
import {AppRoutingModule} from './app-routing.module';

import {AccordionModule} from 'primeng/accordion';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {AvatarModule} from 'primeng/avatar';
import {AvatarGroupModule} from 'primeng/avatargroup';
import {BadgeModule} from 'primeng/badge';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {ButtonModule} from 'primeng/button';
import {CalendarModule} from 'primeng/calendar';
import {CardModule} from 'primeng/card';
import {CarouselModule} from 'primeng/carousel';
import {CascadeSelectModule} from 'primeng/cascadeselect';
import {ChartModule} from 'primeng/chart';
import {CheckboxModule} from 'primeng/checkbox';
import {ChipModule} from 'primeng/chip';
import {ChipsModule} from 'primeng/chips';
import {CodeHighlighterModule} from 'primeng/codehighlighter';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmPopupModule} from 'primeng/confirmpopup';
import {ColorPickerModule} from 'primeng/colorpicker';
import {ContextMenuModule} from 'primeng/contextmenu';
import {DataViewModule} from 'primeng/dataview';
import {DialogModule} from 'primeng/dialog';
import {DividerModule} from 'primeng/divider';
import {DropdownModule} from 'primeng/dropdown';
import {FieldsetModule} from 'primeng/fieldset';
import {FileUploadModule} from 'primeng/fileupload';
import {FullCalendarModule} from 'primeng/fullcalendar';
import {GalleriaModule} from 'primeng/galleria';
import {InplaceModule} from 'primeng/inplace';
import {InputNumberModule} from 'primeng/inputnumber';
import {InputMaskModule} from 'primeng/inputmask';
import {InputSwitchModule} from 'primeng/inputswitch';
import {InputTextModule} from 'primeng/inputtext';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {KnobModule} from 'primeng/knob';
import {LightboxModule} from 'primeng/lightbox';
import {ListboxModule} from 'primeng/listbox';
import {MegaMenuModule} from 'primeng/megamenu';
import {MenuModule} from 'primeng/menu';
import {MenubarModule} from 'primeng/menubar';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {MultiSelectModule} from 'primeng/multiselect';
import {OrderListModule} from 'primeng/orderlist';
import {OrganizationChartModule} from 'primeng/organizationchart';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {PaginatorModule} from 'primeng/paginator';
import {PanelModule} from 'primeng/panel';
import {PanelMenuModule} from 'primeng/panelmenu';
import {PasswordModule} from 'primeng/password';
import {PickListModule} from 'primeng/picklist';
import {ProgressBarModule} from 'primeng/progressbar';
import {RadioButtonModule} from 'primeng/radiobutton';
import {RatingModule} from 'primeng/rating';
import {RippleModule} from 'primeng/ripple';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import {ScrollTopModule} from 'primeng/scrolltop';
import {SelectButtonModule} from 'primeng/selectbutton';
import {SidebarModule} from 'primeng/sidebar';
import {SkeletonModule} from 'primeng/skeleton';
import {SlideMenuModule} from 'primeng/slidemenu';
import {SliderModule} from 'primeng/slider';
import {SplitButtonModule} from 'primeng/splitbutton';
import {SplitterModule} from 'primeng/splitter';
import {StepsModule} from 'primeng/steps';
import {TabMenuModule} from 'primeng/tabmenu';
import {TableModule} from 'primeng/table';
import {TabViewModule} from 'primeng/tabview';
import {TagModule} from 'primeng/tag';
import {TerminalModule} from 'primeng/terminal';
import {TieredMenuModule} from 'primeng/tieredmenu';
import {TimelineModule} from 'primeng/timeline';
import {ToastModule} from 'primeng/toast';
import {ToggleButtonModule} from 'primeng/togglebutton';
import {ToolbarModule} from 'primeng/toolbar';
import {TooltipModule} from 'primeng/tooltip';
import {TreeModule} from 'primeng/tree';
import {TreeTableModule} from 'primeng/treetable';
import {VirtualScrollerModule} from 'primeng/virtualscroller';

import {AppComponent} from './app.component';
import {AppCodeModule} from './layout/app.code.component'
import {AppMainComponent} from './app.main.component';
import {AppConfigComponent} from './layout/app.config.component';
import {AppNotfoundComponent} from './pages/app.notfound.component';
import {AppErrorComponent} from './pages/app.error.component';
import {AppAccessdeniedComponent} from './pages/app.accessdenied.component';
import {AppLoginComponent} from './pages/app.login.component';
import {AppMenuComponent} from './layout/sidebar/app.menu.component';
import {AppMenuitemComponent} from './layout/sidebar/app.menuitem.component';
import {AppTopBarComponent} from './layout/header/app.topbar.component';
import {AppFooterComponent} from './layout/footer/app.footer.component';

import { MenuService } from './layout/app.menu.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { HistoryComponent } from './Modules/Components/History/history.component';
import { ScheduleComponent } from './Modules/Components/schedule/schedule.component';
import { LoginComponent } from './modules/Components/login/login.component';
import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';
import { ForgetpasswordComponent } from './modules/Components/forgetpassword/forgetpassword.component';
import { ChangepasswordComponent } from './modules/Components/changepassword/changepassword.component';
import { PatientCodeVerificationComponent } from './modules/Components/patientcodeverification/patientcodeverification.component';
import { CounterPipe } from './modules/Pipes/counter.pipe';
import { PatientResultComponent } from './modules/Components/patientResult/patientResult.component';
import { ServiceInstructionComponent } from './modules/Components/serviceInstruction/serviceInstruction.component';
import { PatCodeRegisterationComponent } from './Modules/Components/pat-code-registeration/pat-code-registeration.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { LoadingSpinnerComponent } from './Modules/Components/loading-spinner/loading-spinner.component';
import { TopbarBlankComponent } from './Modules/Components/topbar-blank/topbar-blank.component';
import { DoctorScheduleComponent } from './Modules/Components/doctor-schedule/doctor-schedule.component';
import { ConfigService } from './core/services/config/config.service';
import {APP_INITIALIZER} from '@angular/core';
import { RequestComponent } from './Modules/Components/request/request.component';
import { SpecialtyComponent } from './Modules/Components/specialty/specialty.component';
import { CategoryComponent } from './Modules/Components/category/category.component';
import { ClinicdoctorComponent } from './Modules/Components/clinicdoctor/clinicdoctor.component';
import { RequestDetailsComponent } from './Modules/Components/request-details/request-details.component';
import { PaymentComponent } from './Modules/Components/payment/payment.component';
import { DoctorAppointmentsComponent } from './Modules/Components/doctor-appointments/doctor-appointments.component';
import { SafePipe } from './Modules/Pipes/safe.pipe';
import { PaymentSuccessComponent } from './Modules/Components/payment-success/payment-success.component';
import { PaymentFailComponent } from './Modules/Components/payment-fail/payment-fail.component';
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import { RegisterComponent } from './Modules/Components/register/register.component';
import { CustomRegisterationComponent } from './Modules/Components/custom-registeration/custom-registeration.component';
import { CustomLoginComponent } from './Modules/Components/custom-login/custom-login.component';
import { CustomForgetPasswordComponent } from './Modules/Components/custom-forget-password/custom-forget-password.component';
import { FormDirective } from './Modules/Directives/form-directive.directive';
import { SiteLogoComponent } from './Modules/Components/site-logo/site-logo.component';
import { ServicesComponent } from './Modules/Components/services/services.component';
import { LanguageComponent } from './Modules/Components/language/language.component';
import { MillensysPoweredComponent } from './Modules/Components/millensys-powered/millensys-powered.component';

class LowerQueryCaseUrlSerializer extends DefaultUrlSerializer {
    parse(url: string): UrlTree {
        var urlList = url.split('?');
        if(urlList.length > 1)
        {
            var mainUrl = urlList[0].toLowerCase();
            urlList = urlList.slice(1);
            return super.parse(mainUrl + '?' + urlList.join('?'));
        }
        else
        {
            return super.parse(url.toLowerCase()); 
        }
    }
}
// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http,'./assets/i18n/', '.json');
}
export function getApiRoot(http: HttpClient) {
    return () => {
      return http.get('./assets/global/global.json').toPromise().then(async data => {
        let baseUrl =  data['ApiRoot'];
        if(baseUrl.startsWith('http')){
            ConfigService.ApiRoot = data['ApiRoot'];
        }else{
            ConfigService.ApiRoot = location.origin;
        }
        let aPPMainsettingsUrl= ConfigService.ApiRoot + "api/Mobile/APPMainsettings";
        await http.get(aPPMainsettingsUrl).toPromise().then(data => {
            var APPMainsettings:any = data;
            ConfigService.APPMainsettings = APPMainsettings;
        });
      });
    };
}
@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        AppCodeModule,
        HttpClientModule,
        BrowserAnimationsModule,
        AccordionModule,
        AutoCompleteModule,
        AvatarModule,
        AvatarGroupModule,
        BadgeModule,
        BreadcrumbModule,
        ButtonModule,
        CalendarModule,
        CardModule,
        CarouselModule,
        CascadeSelectModule,
        ChartModule,
        CheckboxModule,
        ChipModule,
        ChipsModule,
        CodeHighlighterModule,
        ConfirmDialogModule,
        ConfirmPopupModule,
        ColorPickerModule,
        ContextMenuModule,
        DataViewModule,
        DialogModule,
        DividerModule,
        DropdownModule,
        FieldsetModule,
        FileUploadModule,
        FullCalendarModule,
        GalleriaModule,
        InplaceModule,
        InputNumberModule,
        InputMaskModule,
        InputSwitchModule,
        InputTextModule,
        InputTextareaModule,
        KnobModule,
        LightboxModule,
        ListboxModule,
        MegaMenuModule,
        MenuModule,
        MenubarModule,
        MessageModule,
        MessagesModule,
        MultiSelectModule,
        OrderListModule,
        OrganizationChartModule,
        OverlayPanelModule,
        PaginatorModule,
        PanelModule,
        PanelMenuModule,
        PasswordModule,
        PickListModule,
        ProgressBarModule,
        RadioButtonModule,
        RatingModule,
        RippleModule,
        ScrollPanelModule,
        ScrollTopModule,
        SelectButtonModule,
        SidebarModule,
        SkeletonModule,
        SlideMenuModule,
        SliderModule,
        SplitButtonModule,
        SplitterModule,
        StepsModule,
        TableModule,
        TabMenuModule,
        TabViewModule,
        TagModule,
        TerminalModule,
        TimelineModule,
        TieredMenuModule,
        ToastModule,
        ToggleButtonModule,
        ToolbarModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,       
        VirtualScrollerModule,
        TranslateModule.forRoot(
            {
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient]
                },
                defaultLanguage: 'en'
            }
        ),
        ProgressSpinnerModule,
        NgxUsefulSwiperModule,
        ReactiveFormsModule
    ],
    declarations: [
        AppComponent,
        AppMainComponent,
        AppMenuComponent,
        AppMenuitemComponent,
        AppConfigComponent,
        AppTopBarComponent,
        AppFooterComponent,
        HistoryComponent,
        AppNotfoundComponent,
        AppErrorComponent,
        AppAccessdeniedComponent,
        AppLoginComponent,
        ForgetpasswordComponent,
        ScheduleComponent,
        LoginComponent,
        ChangepasswordComponent,
        PatientCodeVerificationComponent,
        CounterPipe,
        SafePipe,
        PatientResultComponent,
        DoctorScheduleComponent,
        
        ServiceInstructionComponent,
        PatCodeRegisterationComponent,
        LoadingSpinnerComponent,
        TopbarBlankComponent,
        RequestComponent,
        SpecialtyComponent,
        CategoryComponent,
        ClinicdoctorComponent,
        PaymentComponent,
        RequestDetailsComponent,
        DoctorAppointmentsComponent,
        PaymentSuccessComponent,
        PaymentFailComponent,
        RegisterComponent,
        CustomRegisterationComponent,
        CustomLoginComponent,
        CustomForgetPasswordComponent,
        SiteLogoComponent,
        MillensysPoweredComponent,
        ServicesComponent,
        LanguageComponent,
        FormDirective
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: getApiRoot,
            multi: true,
            deps: [HttpClient]
        },
        {provide: LocationStrategy, useClass: PathLocationStrategy},
        
         MenuService,MessageService,ConfirmationService,
        {provide:UrlSerializer,useClass:LowerQueryCaseUrlSerializer},
        DatePipe
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
